import { NotionStore, StoreCountry, StoreState } from "constants/store.dataType";

const notionStoreDataService = {
  filterStoreData(store: NotionStore): boolean {
    let canAdd = true;
    if (process.env.NEXT_PUBLIC_ENV == 'production' && store.publishStatus != process.env.NEXT_PUBLIC_ENV) {
      canAdd = false;
    }
    else if (store.publishStatus != 'production' && store.publishStatus != 'development') {
      canAdd = false;
    }
    else if (store.hideInEcommerce) {
      canAdd = false;
    }

    if (store.slug == 'union-station') {
      canAdd = false;
    }

    return canAdd;

  },
  filterStoreListData(data: StoreCountry[]): StoreCountry[] {

    return data.map(country => ({
      ...country,
      states: country.states.map(state => ({
        ...state,
        stores: state.stores.filter(store => this.filterStoreData(store))
      }))
    }));


  },
  async getStoresDropdownData(locale: string): Promise<any> {
    const stores = await this.getStores();

    const allstores =
      locale === 'ca'
        ? stores.reverse()
        : stores;


    allstores.forEach((country: any) => {
      country.states.forEach((state: any) => {
        state.stores = state.stores.filter((store: any) => store.slug !== "replenish" && store.slug !== "brunswick");
      });
    });

    const countryList: any[] = [];
    allstores.map((countryData: StoreCountry) => {

      const stateList: any[] = [];
      countryData.states.map((stateData: StoreState) => {

        const storeList: any[] = [];
        stateData.stores.map((store: NotionStore) => {
          storeList.push({
            "name": store.name,
            "path": "/stores/" + store.slug,
            "googleReviewUrl": store.googleReviewLink
          });
        });

        stateList.push({
          "code": stateData.state.name,
          "name": stateData.state.name,
          "path": '/stores/' + stateData.state.slug,
          "storeList": storeList
        });

      })
      countryList.push({
        "code": countryData.country.name.substring(0, 2).toUpperCase(),
        "name": countryData.country.name,
        "stateList": stateList
      });


    })

    return countryList;
  },
  async getStores(): Promise<any> {
    const response = await fetch(`${process.env.NEXT_PUBLIC_NOTION_S3_URL}/store/stores.json`, { cache: 'no-store' });
    if (response.ok === false) {
      return null;
    }
    const posts = await response.json();
    const filteredStores = this.filterStoreListData(posts);
    return filteredStores;
  },
  async getHolidayData(country: string): Promise<any> {
    const response = await fetch(`${process.env.NOTION_S3_URL}/store/holidays_${country}.json`, { cache: 'no-store' });
    if (!response.ok) {
      return [];
    }
    const posts = await response.json();
    return posts;
  },
  async getCityData(slug: string): Promise<any> {
    const response = await fetch(`${process.env.NOTION_S3_URL}/store/store_${slug}.json`, { cache: 'no-store' });
    if (response.ok === false) {
      return null;
    }
    const posts = await response.json();
    const updatedStores = posts.stores.filter((store: any) => store.slug !== 'union-station' &&  store.slug !== 'replenish' );

    const updatedData = {
      ...posts,
      stores: updatedStores
    };

    return updatedData;
    return posts;
  },
  async getStoreData(slug: string): Promise<any> {
    const response = await fetch(`${process.env.NOTION_S3_URL}/store/store_${slug}.json`, { cache: 'no-store' });
    if (response.ok === false) {
      return null;
    }
    const posts = await response.json();
    return posts;
  },
};

export default notionStoreDataService;

